/*工资发放明细 */
import { $http } from "./index";

//获取工资发放明细列表
export const salaryrecordemployee_list = (params) => {
  return $http.get("/admin/SalaryRecordEmployee/index", { params });
};
